import { QuizOutletContextType } from '@quizzach/interfaces';
import { fadeInConfig } from '@quizzach/motion';
import { H3, Colors, Text, TextSize } from '@quizzach/styles';
import {
	QuizSlidesContainer,
	QuestionNumbers,
	QuestionTitle,
	QuestionContainer,
	QuestionText,
} from '@quizzach/play-styles';
import { useOutletContext } from 'react-router-dom';
import { BottomNav } from '@quizzach/components';
import { BottomNavMobile } from '@quizzach/layouts';
import { useWindowListener } from '@quizzach/contexts';
import { useTranslation } from 'react-i18next';

export const QuizPuzzleIntro = () => {
	const { t } = useTranslation();
	const { touchDevice } = useWindowListener();
	const { quiz, currentQuestionNumber, handlePrevious, handleNext } =
		useOutletContext<QuizOutletContextType>();

	return (
		<QuizSlidesContainer>
			<div className='quiz-break-content pop-in'>
				<div className='quiz-break-main'>
					<H3 color={Colors.textMain}>{t('quiz.puzzle.title')}</H3>
					<Text
						style={{ margin: 0 }}
						$size={touchDevice ? TextSize.m : TextSize.l}
						color={Colors.textSoft}
					>
						{t('quiz.puzzle.description1')}
					</Text>
					<br />
					<Text
						style={{ margin: 0 }}
						$size={touchDevice ? TextSize.m : TextSize.l}
						color={Colors.textSoft}
					>
						{t('quiz.puzzle.description2')}
					</Text>
				</div>
			</div>
			{touchDevice ? (
				<BottomNavMobile
					question={quiz?.questions[currentQuestionNumber - 1]}
					handleNext={handleNext}
					handlePrevious={handlePrevious}
					isPremadeOrEstimation={true}
					type='plain'
				/>
			) : (
				<BottomNav
					question={quiz?.questions[currentQuestionNumber - 1]}
					handleNext={handleNext}
					handlePrevious={handlePrevious}
					isPremadeOrEstimation={true}
					type='plain'
				/>
			)}
		</QuizSlidesContainer>
	);
};

export const QuizPuzzleAnswer = () => {
	const { t } = useTranslation();
	const { touchDevice } = useWindowListener();

	const { quiz, currentQuestionNumber, handlePrevious, handleNext } =
		useOutletContext<QuizOutletContextType>();

	return (
		<QuizSlidesContainer>
			<div className='quiz-break-content pop-in' style={{ width: '100%' }}>
				<div className='quiz-break-main'>
					<H3 color={Colors.textMain}>{t('quiz.puzzle.answerReveal')}</H3>
				</div>

				<QuestionContainer
					color={Colors.transparent}
					{...fadeInConfig()}
					style={{ width: '100%', flexDirection: 'column' }}
					$answer
				>
					<div className={touchDevice ? '' : 'flex'}>
						<QuestionTitle $small style={{ width: '180px' }}>
							{t('quiz.puzzle.answerLabel')}
						</QuestionTitle>
						<div className='answer'>
							<QuestionText style={{ margin: 0 }}>
								<div className='bold answer-text'>
									{quiz?.premade_quiz?.puzzle_answer}
								</div>
							</QuestionText>
						</div>
					</div>

					<div className={touchDevice ? 'flex points' : 'flex'}>
						<QuestionTitle
							$small
							style={{ width: touchDevice ? 'unset' : '180px' }}
						>
							{t('quiz.puzzle.pointsLabel')}
						</QuestionTitle>
						<QuestionNumbers style={{ margin: !touchDevice ? 0 : '0px 20px' }}>
							1
						</QuestionNumbers>
					</div>
				</QuestionContainer>
			</div>
			{touchDevice ? (
				<BottomNavMobile
					question={quiz?.questions[currentQuestionNumber - 1]}
					handleNext={handleNext}
					handlePrevious={handlePrevious}
					isPremadeOrEstimation={true}
					type='plain'
				/>
			) : (
				<BottomNav
					question={quiz?.questions[currentQuestionNumber - 1]}
					handleNext={handleNext}
					handlePrevious={handlePrevious}
					isPremadeOrEstimation={true}
					type='plain'
				/>
			)}
		</QuizSlidesContainer>
	);
};
